import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Segment, TextArea, Popup } from 'semantic-ui-react'


// import { init, send } from 'emailjs-com';
import axios from 'axios';
// init('user_gx0Jid2obrg3E1RLZDMBo');

class ApplicantsSendAAEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      to: '',
      subject: '',
      message: ''
    };
  }
  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  onSubmit = (e) => {
    e.preventDefault();
    const data = {
      to: this.state.to,
      subject: this.state.subject,
      message: this.state.message
    }
    axios
      .request({
        method: 'post',
        url: process.env.REACT_APP_URL+'/applicants/sendEmail',
        data: data
      })
      .then(response => {
        alert(`Email sent!`)
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });

      axios
        .request({
          method: 'put',
          url: process.env.REACT_APP_URL+'/applicants/'+this.props.applicant.applicantId,
          data: {sentAAEmail: true}
        })
        .then(response => {
          this.props.getApplicants();
          alert(`Check the school's email address for confirmation.`)
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            alert(`${error.response.data.error.message}`);
          } else if (error.request) {
            alert(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            alert('Error. Please contact your administrator for assistance.');
          }
        });
        this.closeModal();
  }



  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value });
  }

  updateState = (applicant) => {
    let subject = 'SALIS Enrollment', message = '';
    const applicantName =  `${applicant.lastName}, ${applicant.firstName}`;

    if (applicant.applicationType === 'new') {
      subject = `SALIS Enrollment for ${applicantName} (New Student)`
    }

    if (applicant.isPassed) {
      message = `
        Good day!

        Thank you for communicating with us. Congratulations! We would like to welcome ${applicantName} to the SALIS Family.

        You will receive another email containing the payment details.

        SALIS Enrollment Team
        `
    } else {
      message = `
        Good day!

        Thank you for communicating with us. Please submit past grades for ${applicantName}.

        SALIS Enrollment Team
        `
    }
    this.setState({to: applicant.email, subject, message})
  }

  componentDidMount = () => {
    this.updateState(this.props.applicant);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (JSON.stringify(prevProps.applicant) !== JSON.stringify(this.props.applicant) ) {
      this.updateState(this.props.applicant);
    }
  }


  render() {
    return (
      <Modal
        trigger={
          <Popup
            on='hover'
            position='bottom center'
            size='tiny'
            trigger={
              <Button icon size='tiny' disabled={this.props.applicant.applicationType === 'old' ? true : this.props.applicant.sentAAEmail ? true: false} onClick={this.openModal}>
                <Icon name='mail' />
              </Button>
            }
          >
            Send Academic Assessment Email
          </Popup>

        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Send Email</Modal.Header>
        <Modal.Content>
          <Segment>
            <Form onSubmit={this.onSubmit}>
              <Form.Field control={Input} value={this.state.to} name='to' label='To' placeholder='Email' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.subject} name='subject' label='Subject' placeholder='Subject' onChange={this.handleChange}/>
              <strong>Message</strong>
              <Form.Field>
                <TextArea
                  name = "message"
                  value={this.state.message}
                  onChange = {this.handleInputChange}
                  rows = {15}
                 />
              </Form.Field>
              <Button type='submit'>Submit</Button>
            </Form>
          </Segment>
        </Modal.Content>
        <Modal.Actions>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default ApplicantsSendAAEmail;
